import { create } from 'zustand';
import api from '../services/api.js';

const TOKEN_KEY = 'access_token';
let bootstrapStarted = false;

export const useAuthStore = create((set, get) => ({
  user: null,
  token: typeof window !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null,
  loading: false,
  initialized: false,

  bootstrap: () => {
    if (bootstrapStarted) return;
    bootstrapStarted = true;
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      set({ initialized: true, user: null, token: null });
      return;
    }
    set({ token });
    get()
      .fetchProfile()
      .finally(() => set({ initialized: true }));
  },

  fetchProfile: async () => {
    try {
      const { data } = await api.get('/v1/auth/me');
      if (data.success) {
        set({ user: data.data });
      }
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      set({ user: null, token: null });
    }
  },

  login: async (email, password) => {
    set({ loading: true });
    try {
      const { data } = await api.post('/v1/auth/login', { email, password });
      if (!data.success) throw new Error(data.message || 'Credenciales inválidas');
      const token = data.data.token;
      localStorage.setItem(TOKEN_KEY, token);
      set({ token, user: data.data.user, loading: false });
      return true;
    } catch (e) {
      set({ loading: false });
      throw e;
    }
  },

  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    set({ user: null, token: null });
  },

  updateProfile: async (payload) => {
    const { data } = await api.put('/v1/auth/me', payload);
    if (!data.success) throw new Error(data.message || 'No se pudo actualizar el perfil');
    set({ user: data.data });
    return data.data;
  },
}));
